/**
 * Events that should be bound to the window
 */
import CONSTANT from '../constant'

export default function (target) {
  target.prototype.bindWindowEvents = function (resizeHide) {
    // ReactTooltip.hide
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide)
    window.addEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide, false)

    // ReactTooltip.rebuild
    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild)
    window.addEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false)

    // ReactTooltip.show
    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow)
    window.addEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow, false)

    // Resize
    if (resizeHide) {
      window.removeEventListener('resize', this.onWindowResize)
      window.addEventListener('resize', this.onWindowResize, false)
    }
  }

  target.prototype.unbindWindowEvents = function () {
    window.removeEventListener(CONSTANT.GLOBAL.HIDE, this.globalHide)
    window.removeEventListener(CONSTANT.GLOBAL.REBUILD, this.globalRebuild)
    window.removeEventListener(CONSTANT.GLOBAL.SHOW, this.globalShow)
    window.removeEventListener('resize', this.onWindowResize)
  }

  /**
   * invoked by resize event of window
   */
  target.prototype.onWindowResize = function () {
    if (!this.mount) return
    this.hideTooltip()
  }
}
